<div class="advisory-container">
  <div class="advisory-header">
    <h1>Rapporter</h1>
    <p>
      Opret, gem og download rapporter — advisering kan aktiveres i
      indstillingerne
    </p>
  </div>

  @if (!showWizard) {
  <div class="list-header">
    <button mat-raised-button color="primary" (click)="startCreateWizard()">
      <mat-icon>add</mat-icon> Opret rapport
    </button>
  </div>
  <mat-card class="advisory-table-card">
    <mat-card-content>
      <table
        mat-table
        [dataSource]="advisories"
        class="advisory-table"
        style="width: 100%"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Navn</th>
          <td mat-cell *matCellDef="let a">
            <div class="name-cell">
              <mat-chip color="primary" selected>{{
                getReportTypeLabel(a)
              }}</mat-chip>
              <span>{{ a.name }}</span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="paths">
          <th mat-header-cell *matHeaderCellDef>Uddannelsesveje</th>
          <td mat-cell *matCellDef="let a">
            <mat-chip-set class="paths-chip-set">
              @if (isPathsExpanded(a)) {
              <mat-chip
                class="paths-toggle-chip"
                (click)="togglePathsExpanded(a, $event)"
              >
                Skjul
              </mat-chip>
              } @for (pid of visiblePathIds(a); track pid) {
              <mat-chip>{{ getPathName(pid) }}</mat-chip>
              } @if (hiddenPathCount(a) > 0 && !isPathsExpanded(a)) {
              <mat-chip
                class="paths-toggle-chip"
                (click)="togglePathsExpanded(a, $event)"
              >
                +{{ hiddenPathCount(a) }} mere
              </mat-chip>
              }
            </mat-chip-set>
          </td>
        </ng-container>
        <ng-container matColumnDef="recipients">
          <th mat-header-cell *matHeaderCellDef>Modtagere</th>
          <td mat-cell *matCellDef="let a">
            @if (hasAdvisering(a)) {
            <span>{{ a.recipient_user_ids.length }} bruger(e)</span>
            } @if (!hasAdvisering(a)) {
            <span class="muted">—</span>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="intervals">
          <th mat-header-cell *matHeaderCellDef>Intervaller / Periode</th>
          <td mat-cell *matCellDef="let a">{{ getIntervalLabel(a) }}</td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let a">
            <mat-chip [color]="a.is_active ? 'primary' : 'warn'" selected>
              {{ a.is_active ? "Aktiv" : "Inaktiv" }}
            </mat-chip>
          </td>
        </ng-container>
        <ng-container matColumnDef="lastSent">
          <th mat-header-cell *matHeaderCellDef>Sidst sendt</th>
          <td mat-cell *matCellDef="let a">
            {{ a.last_sent_at ? (a.last_sent_at | date : "dd/MM/yyyy") : "—" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Handlinger</th>
          <td mat-cell *matCellDef="let a">
            <button
              mat-icon-button
              matTooltip="Download PDF"
              (click)="downloadAdvisoryPDF(a)"
            >
              <mat-icon>download</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Rediger" (click)="onEdit(a)">
              <mat-icon>edit</mat-icon>
            </button>
            @if (hasAdvisering(a)) {
            <button
              mat-icon-button
              matTooltip="Send nu"
              (click)="sendAdvisoryNow(a)"
            >
              <mat-icon>send</mat-icon>
            </button>
            }
            <button
              mat-icon-button
              matTooltip="Toggle aktiv"
              (click)="toggleAdvisory(a)"
            >
              <mat-icon>{{ a.is_active ? "pause" : "play_arrow" }}</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="Slet"
              color="warn"
              (click)="deleteAdvisory(a)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </mat-card-content>
  </mat-card>
  } @if (showWizard) {
  <app-duna-report-wizard
    [context]="wizardContext"
    (cancelled)="onWizardCancelled()"
    (saved)="onWizardSaved()"
  >
  </app-duna-report-wizard>
  }
</div>
